import ExaminationEventCreation from './ExaminationEventCreation';

export default ExaminationEventCreation;
